import { useEffect, useState } from 'react';
import { A20, A20Output } from 'api/U002';
import { FetchError } from 'api/API';

export function useValidatePhoneSession(
  sessionId: string
): [A20Output | undefined, boolean, Error | null, () => void] {
  const [loading, setLoading] = useState<boolean>(true);
  const [user, setUser] = useState<A20Output>();
  const [err, setError] = useState<Error | null>(null);

  const [refreshCount, setRefreshCount] = useState<number>(0);
  const refresh = () => setRefreshCount(refreshCount + 1);

  const fetchUser = async (sessionId: string, cancellation: AbortSignal) => {
    return await A20({ sessionId }, cancellation);
  };

  useEffect(() => {
    if (!sessionId) {
      return;
    }
    const controller = new AbortController();
    const cancellation = controller.signal;
    async function fetch() {
      setLoading(true);
      setError(null);
      try {
        const user = await fetchUser(sessionId, cancellation);
        setUser(user);
      } catch (err) {
        console.error({ err });
        if (err instanceof FetchError) {
          const errorData = await err.response.json();
          const flooredError = new Error(errorData.message || `HTTP ERROR: ${err.message}`);
          setError(flooredError);
        } else {
          const flooredError = new Error(`unknown error. ${err}`);
          setError(flooredError);
        }
      } finally {
        setLoading(false);
      }
    }

    fetch();
    return () => {
      // controller.abort()
    };
  }, [sessionId, refreshCount]);

  return [user, loading, err, refresh];
}
